<template>
    <main-content>
        <transactions-report-filter
                :action="filterAction"
                :exportExcel="exportToExcel"
                :gateway="gateway"
                :psp="data.psp"
                class="shadow-sm rounded"
        >
        </transactions-report-filter>
        <div class="mt-3">
            <kt-row>
                <kt-col lg="3" md="3" xs="12">
                    <div class="kt-portlet">
                        <div class="p-4 rounded shadow-sm bg-white">
                            <h6 class="text-white-in-dark-mode"> {{ $t('label.last_updated') }}</h6>
                            <div class="text-center">
                                <h5 class="fix-margin text-white-in-dark-mode">
                                    {{ reportStatistics.last_updated }}
                                </h5>
                            </div>
                        </div>
                    </div>
                    <div class="position-absolute" style="left:20px;top:13px;cursor: pointer;">
                        <button class="no-border" @click="updateReport($event, query)" >
                            <i class="fa flaticon-refresh" aria-hidden="true"
                               style="font-size: 1.6em; color: #0f9af0"
                               :title="$t('label.reportUpdate')"
                            >
                            </i>
                        </button>
                    </div>
                </kt-col>
                <kt-col lg="3" md="3" xs="12">
                    <div class="kt-portlet">
                        <div class="p-4 rounded shadow-sm bg-white">
                            <h6 class="text-white-in-dark-mode"> {{ $t('label.terminal_title') }}</h6>
                            <div class="text-center">
                                <h4 class="fix-margin text-white-in-dark-mode">
                                    {{ reportStatistics.terminal_title }}
                                </h4>
                            </div>
                        </div>
                    </div>
                </kt-col>
                <kt-col lg="3" md="3" xs="12">
                    <div class="kt-portlet">
                        <div class="p-4 rounded shadow-sm bg-white">
                            <h6 class="text-white-in-dark-mode"> {{ $t('label.total_transactions') }}</h6>
                            <div class="text-center">
                                <h4 class="fix-margin text-white-in-dark-mode">
                                    {{ reportStatistics.total_transactions }}
                                    <span style="font-size: 1.5rem">
                                        {{' ' + $t('currency.rial')}}
                                    </span>
                                </h4>
                            </div>
                        </div>
                    </div>
                </kt-col>
                <kt-col lg="3" md="3" xs="12">
                    <div class="kt-portlet">
                        <div class="p-4 rounded shadow-sm bg-white">
                            <h6 class="text-white-in-dark-mode">{{ $t('label.succeeded_transactions_number') }}</h6>
                            <div class="text-center">
                                <h4 class="fix-margin text-white-in-dark-mode"> {{ reportStatistics.number }} </h4>
                            </div>
                        </div>
                    </div>
                </kt-col>
            </kt-row>
        </div>
        <div>
            <kt-datatable v-bind="datatableProps" ref="datatable"></kt-datatable>
        </div>
    </main-content>
</template>

<script>
    import $ from 'jquery'
    import { ApiUrl } from '@/common/api.service'
    import columns from './datatable/transactions-report-columns'
    import transactionsReportFilter from './components/transactions-report-filter'
    import { AuthorizationHeader } from '@/common/jwt.service'
    import mainContent from '@/components/main-content'
    import {mapGetters} from "vuex";
    import store from '@/store'
    import axios from "axios";
    import toastr from "toastr";
    import { i18n } from '@/plugins/i18n'

    export default {
        name: "gateway_transactions_report",
        components: {
            mainContent,
            'transactions-report-filter': transactionsReportFilter
        },
        data() {
            return {
                headerAction: {
                    left: '10px',
                    top: '10px',
                    position: 'absolute'
                },
                query: {},
                shop_type: 'pf',
                data: {
                  gateway_id: this.$route.params.hashid,
                  psp: 'novin',
                },
            }
        },
        computed: {
            datatableProps() {
                return {
                    id: "datatable",
                    data: {
                        type: 'remote',
                        source: {
                            read: {
                                url: ApiUrl.path(`gateway/gateway-transactions-report/${this.data.gateway_id}?query[shop_type]=${this.shop_type}&query[psp]=${this.data.psp}`),
                                method: 'GET',
                                headers: AuthorizationHeader,
                                map: (res) => {
                                    return res.data.data.data
                                },
                                params: {
                                    query: this.query,
                                },
                                success: function (res) {
                                    store.dispatch('gateway/fetchReportStatistics', res.data.data)
                                }
                            }
                        },
                        pageSize: 15,
                        serverPaging: true,
                        serverFiltering: true,
                        serverSorting: true,
                    },
                    pagination: false,
                    sortable: true,
                    columns: columns,
                }
            },
            ...mapGetters('gateway', [
                'status', 'reportStatistics' , 'gateways'
            ]),
            gateway(){
              return this.gateways.find((item) => item.id == this.data.gateway_id)
            }
        },
        methods: {
            updateReport(e, query) {
                query.reportUpdate = true
                this.query = query
                if (this.$refs.datatable.KTDatatable) {
                    this.$refs.datatable.reload()
                }
            },
            exportToExcel(e, query){
                let btn = $('#export_psp_transations_btn')

                this.query = query
                axios({
                    url: ApiUrl.path(`gateway/export-transactions-psp-report/${this.data.gateway_id}`),
                    method: 'GET',
                    params: this.query,
                    responseType: 'blob',
                }).then((response) => {
                    var fileURL = window.URL.createObjectURL(new Blob([response.data]));
                    var fileLink = document.createElement('a');

                    fileLink.href = fileURL;
                    fileLink.setAttribute('download', 'transactions.xlsx');
                    document.body.appendChild(fileLink);

                    fileLink.click();
                }).catch(({response}) => {
                    this.toastr.error(i18n.t('message.an_error_accord'))
                })
            },
            filterAction(e, query) {
                query.reportUpdate = false
                this.data.psp = query.psp
                this.query = query
                if (this.$refs.datatable.KTDatatable) {
                    this.$refs.datatable.reload()
                }
            },
            fetchReportStatistics(data) {
              store.dispatch('gateway/fetchReportStatistics', data)
            },
        },
        async created () {
          await store.dispatch('gateway/fetch')
        }
    }
</script>

<style>
</style>